module.exports = __webpack_public_path__ + "img/play-store.16dcc7bf.png";